import React from 'react';
import '../styles/featuredservice.css'
import AnimatedArrowButton from './AnimatedArrowButton';
import myvideo from '../assets/featured-service.mp4'


const FeaturedServices = () => {

    return(<div className='featuredservice'>

        
            <div className='featuredservice-outer' >
            <div className='featuredservice-inner' >
            
            <div className='myservices' style={{display:'flex',padding:'25px',borderBottom:'1px solid #383838',gap:'10px'}}>
                        
                        <h4 style={{color:'#FFD52B'}}>Featured Services</h4>
                        
            </div>
            <div className='myservices' style={{display:'flex',padding:'25px',gap:'10px',paddingTop:"25px"}}>
                        
                        <div className='services-msg' style={{textAlign:'left'}}>
                            <div style={{display:'flex' , alignItems:'start', justifyContent:'space-between'}}><h1 style={{fontWeight:"600"}}>Service Robots</h1> <div className='button1'> <AnimatedArrowButton  text="Consultation" width='250px' link="#"   /></div> </div>
                            <p style={{color:'white', fontSize:"14px"}}>Revolutionizing industries with autonomous service robots for logistics, healthcare, hospitality, and more. Automate routine tasks, Enhance productivity and reduce costs and adaptable for various industries.</p>
                            <div className='button2'> <AnimatedArrowButton  text="Consultation" link="#"   /></div> 
                        </div>
            </div>
            <div style={{display:'flex', alignItems:'center',justifyContent:'center'}}>
            <div className='featuredservicevideo' style={{width:'90%', height:'17rem'  ,overflow:"hidden", borderRadius:'8px'}}>
            <video autoPlay muted loop style={{objectFit:'cover',width:'100%',height:'100%'}}>
             <source src={myvideo} type="video/mp4" /></video>
            
            </div>
            </div>

            </div>
            </div>
        
    

    </div>);

}

export default FeaturedServices;